const getMessageNotice = function (type, message) {
  let successMessage = 'Operated successfully!';
  if(message === 4){
    successMessage = 'Batch Import Complete';
  }else if(message === 1){
    successMessage = 'Added successfully!';
  }else if(message === 3){
    successMessage = 'Deleted successfully!';
  }else if (message === 6){
    successMessage = 'Submission successful.';
  }
  this.$Message.success({
    duration: type === 'error' ? 4 : 2,
    closable: type === 'error' || type === 'info',
    render: h => {
      if(type === 'success'){
        return h('div', [
          h('span', {
            class:['success-notice-bg']
          }, [
            h('span',{
              class:['utm-font utm-ok-icon success-notice-img'],
            })
          ]),
          h('div', {
            class:['success-notice-content']
          }, [
            h('span',{
              style:{
                'text-align':'left',
                'padding-left':'8px',
                'font-size':'16',
                'font-weight':'400'
              },
              class:['message-title']
            }, successMessage)
            /*1: 添加 2: 编辑 3:删除 */
          ]),
        ])
      }else if(type === 'error'){
        return h('div', [
          h('span', {
            class:['success-notice-bg', 'error-notice-bg']
          }, [
            h('span',{
              class:['success-notice-img', 'utm-font utm-error-icon error-notice-img'],
            })
          ]),
          h('div', {
            class:['success-notice-content']
          }, [
            h('span',{
              style:{
                'text-align':'left',
                'padding-left':'8px',
                'font-size':'16px',
              },
              class:['message-title']
            }, 'Operation error!'),
            h('span',{
              style:{
                'text-align':'left',
                'padding-left':'8px',
              },
              class:['message-content']
            }, message)
          ]),
        ])
      }else if(type === 'info'){
        return h('div', [
          h('span', {
            class:['success-notice-bg','info-notice-bg']
          }, [
            h('span',{
              class:['success-notice-img','utm-font utm-icon-hide'],
            })
          ]),
          h('div', {
            class:['message-content']
          }, [
            h('span',{
              style:{
                'text-align':'left',
                'padding-left':'8px',
                'font-size':'16px',
              },
              class:['message-title']
            }, message)
          ]),
        ])
      }
    }
  });
};
export default getMessageNotice;



//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/messageNotice.js
// module id = Ui4z
// module chunks = 15